import React from 'react'
import { useNewTranslation } from 'hooks'
import { CAMPAIGN_STATUS_ENUM } from 'state/campaigns'
import { useTheme } from 'particles/themes/styled'
import { Theme } from 'particles/themes'
import { getCampaignStatusColor, getCampaignStatusTitle } from 'components/utils'
import RoundTag from 'particles/Tag'

interface CampaignStatusLabelProps {
    status: CAMPAIGN_STATUS_ENUM
}

export const getCampaignStatusBackgroundColor = (campaignStatus: CAMPAIGN_STATUS_ENUM, theme: Theme) => {
    switch (campaignStatus) {
        case CAMPAIGN_STATUS_ENUM.FOR_REVIEW: {
            return theme.colors.surface.warningPastel
        }
        case CAMPAIGN_STATUS_ENUM.LIVE: {
            return theme.colors.surface.positivePastel
        }
        case CAMPAIGN_STATUS_ENUM.FOR_EDIT: {
            return theme.colors.indicator.cornsilk
        }
        case CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT: {
            return theme.colors.surface.infoPastel
        }
        case CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH: {
            return theme.colors.surface.warningPastel
        }
        default: // live
            return theme.colors.surface.neutralActionHover
    }
}

const CampaignStatusLabel: React.FC<CampaignStatusLabelProps> = ({ status }) => {
    const [t] = useNewTranslation()
    const theme = useTheme()
    const statusLabel = getCampaignStatusTitle(status, t)
    const statusColor = getCampaignStatusColor(status)
    const backgroundColor = getCampaignStatusBackgroundColor(status, theme)
    const displayStatusLabel = [
        CAMPAIGN_STATUS_ENUM.FOR_REVIEW,
        CAMPAIGN_STATUS_ENUM.FOR_EDIT,
        CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT,
        CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH,
        CAMPAIGN_STATUS_ENUM.LIVE,
    ].includes(status)

    return displayStatusLabel ? (
        <RoundTag
            contentType="neutral"
            customStyle={{
                backgroundColor: backgroundColor,
                color: theme.colors.indicator[statusColor],
                minWidth: '60px',
            }}
            label={statusLabel}
        />
    ) : null
}

export default CampaignStatusLabel
